import React, { useState } from "react";
import Confirmation from "./Confirmation";
import Cancelation from "./Cancelation";
import Availability from "./Availability";
import NoShow from "./NoShow";
import { ButtonGroup } from "@mui/material";
interface IManageCellProps {
  params: any;
}
export default function ManageCell(props: IManageCellProps): JSX.Element {
  const { params } = props;
  const [hideButtons, setHideButtons] = useState<string>("");
  const handleButtonShow = (hideButton: string): void => {
    setHideButtons(hideButton);
  };
  return (
    <ButtonGroup variant="contained" size="small">
      {hideButtons !== "confirmation" && (
        <Confirmation rowParams={params.row} UItype={"button"} stateChanger={handleButtonShow} />
      )}
      {hideButtons !== "cancelation" && (
        <Cancelation rowParams={params.row} UItype={"button"} stateChanger={handleButtonShow} />
      )}
      {hideButtons === "" && <Availability rowParams={params.row} />}
      {hideButtons === "" && <NoShow rowParams={params.row} />}
    </ButtonGroup>
  );
}
